import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Img from './../Img';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';
import { Logo } from '..';

const Info = ({ logoUrl = '' }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.info}>
      <div className={styles.logo}>
        <Logo logoUrl={logoUrl} />
      </div>
      <div className={styles.content}>
        {!logoUrl && (
          <div className={(styles.infoImage, styles.custome_image)}>
            <div className={styles.cutome_margin_info_img}>
              <Img
                src="/login-banner.svg"
                alt="Info Illustration"
                width="400"
                height="365"
              />
            </div>
          </div>
        )}
        {!logoUrl && (
          <div>
            <p className={styles.p}>{t('login_info')}</p>
            <p className={styles.copyright}>
              Gupshup &copy; {new Date().getFullYear()}.{' '}
              {t('all_rights_reserved')}.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

Info.defaultProps = {
  graphic: ''
};

Info.propTypes = {
  graphic: PropTypes.string.isRequired
};

export default memo(Info);
